import { AsyncPipe, NgClass } from '@angular/common';
import {
  AfterViewChecked,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  HostBinding,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { AuthRedirectStorageService, CmsLinkComponent } from '@spartacus/core';
import { CmsComponentData, GenericLinkComponent } from '@spartacus/storefront';
import { DeviceDetectorService } from 'ngx-device-detector';
import { Observable, Subscription, of } from 'rxjs';
import { ComponentService } from 'src/app/service/component.service';
import { StorageService } from 'src/app/service/storage/storage.service';
import { LogoutService } from 'src/app/service/user/logout.service';
import { ASM_ENABLED_LOCAL_STORAGE_KEY } from '../asm/asm-constant';

@Component({
  selector: 'app-link',
  templateUrl: './link.component.html',
  styleUrls: ['./link.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [GenericLinkComponent, NgClass, AsyncPipe],
})
export class LinkComponent implements OnInit, AfterViewChecked, OnDestroy {
  deviceInfo: any = null;
  data$: Observable<any> = this.component.data$;
  styleClass: string;
  hasEditPreferenceDiscountBtns: boolean;
  componentDataSub$: Subscription;
  componentData$: any;

  asmEnabled = this.storageService.getLocalStorageItem(ASM_ENABLED_LOCAL_STORAGE_KEY);

  hasRequested = 'false';
  requestSuccess: boolean = false;
  requestSuccessSubs$: Subscription;

  @HostBinding('class.request-account-link') 
  get requestAccountClass(): boolean {
    return this.hasRequested === 'true';
  }
  @HostBinding('class.request-account-link-success') 
  get requestSuccessClass(): boolean {
    return this.requestSuccess;
  }

  constructor(
    public component: CmsComponentData<CmsLinkComponent>,
    private deviceService: DeviceDetectorService,
    private cdr: ChangeDetectorRef,
    private logoutService: LogoutService,
    private storageService: StorageService,
    private authRedirectStorageService: AuthRedirectStorageService,
    private componentService: ComponentService
  ) {}

  ngOnInit() {
    if (this.requestedAccountDisplay === 'true') this.hasRequested = this.requestedAccountDisplay;
    this.requestSuccessSubs$ = this.componentService.requestSuccessSubject$.subscribe(updated => {
      this.requestSuccess = updated;
      this.cdr.markForCheck();
    });
    
    this.deviceInfo = this.deviceService.getDeviceInfo();
    this.componentDataSub$ = this.data$.subscribe((data) => {
      if (data !== null) {
        this.componentData$ = of(data);
        const updateStyleClass = data.styleClass;
        if (this.deviceInfo.browser.toLowerCase() === 'chrome') {
          if (typeof updateStyleClass !== 'undefined') {
            if (updateStyleClass.includes('primary-btn-safari')) {
              this.styleClass = 'button primary-btn';
            } else if (updateStyleClass.includes('secondary-btn-safari')) {
              this.styleClass = 'button secondary-btn';
            } else {
              this.styleClass = data.styleClass;
            }
          }
        } else {
          this.styleClass = data.styleClass;
        }
        this.cdr.detectChanges();
      }
    });
  }

  ngAfterViewChecked() {
    const hasEditPreference = document.querySelector('.myaccount-edit-preferences');
    const hasDiscount = document.querySelector('.myaccount-discounts');
    this.hasEditPreferenceDiscountBtns = hasEditPreference === null && hasDiscount === null ? false : true;
    if (this.hasEditPreferenceDiscountBtns) {
      if (hasEditPreference === null) {
        if (hasDiscount !== null) {
          hasDiscount.classList.add('right');
        }
      } else {
        if (hasDiscount !== null) {
          hasDiscount.classList.remove('right');
        }
      }
    }
  }

  handleClick(url: string, event: MouseEvent) {
    if (url.includes('/logout')) {
      event.preventDefault();
      this.logoutService.logout();
    } else if (url.includes('/login?asm=false')) {
      event.preventDefault();
      this.storageService.clearLocalStorageItem();
      const url = new URL(window.location.href);
      url.searchParams.set('asm', 'false');
      window.location.href = url.toString();
    } else {
      return true;
    }
  }
  getClass(styleClass: string | undefined, url: string) {
    return {
      ...(styleClass ? { [styleClass]: true } : {}),
      'd-none': !this.asmEnabled && url?.includes('/login?asm=false'),
    };
  }

  get requestedAccountDisplay() {
    return this.storageService.getLocalStorageItem('hasRequested');
  }

  ngOnDestroy(): void {
    if (this.componentDataSub$) {
      this.componentDataSub$.unsubscribe();
    }
    this.requestSuccessSubs$?.unsubscribe();
  }
}
